import React, { useState, useEffect } from 'react';
import { Heading } from '../components/Heading';
import { ContentIngram } from '../components/ContentIngram';
import IngramExcelModal from '../components/IngramExcelModal';
import Autocomplete from '../components/Autocomplete';
import { urlInk, endpointGetAccounts, urlPod, endpointDownloadIngramExcel } from '../services/Endpoints';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faClose, faSync, faFileExcel, faToggleOn, faToggleOff, faDownload } from '@fortawesome/free-solid-svg-icons';
import AuthService from '../services/AuthService';
import { theme } from '../theme';



export function Ingram() {
    const [refreshKey, setRefreshKey] = useState(0);
    const [isExcelModalOpen, setIsExcelModalOpen] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [accounts, setAccounts] = useState([]);
    const [filters, setFilters] = useState({
        search: '',
        status: '',
        account: '',
    });

    useEffect(() => {
        console.log("Ingram render");
        getAccounts();
    }, []);

    const getAccounts = async () => {
        try {
            const response = await fetch(`${urlInk}${endpointGetAccounts}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const res = await response.json();
            if (res && res.status === 'success') {
                setAccounts(res.data);
            }
        } catch (error) {
            console.error("Error fetching accounts:", error);
        }
    }


    const handleReload = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleDownloadExcel = async () => {
        try {
            const token = AuthService.getToken();
            const params = new URLSearchParams({
                search: filters.search || '',
                status: filters.status || '',
                account: filters.account || '',
            });
            const response = await fetch(`${urlPod}${endpointDownloadIngramExcel}?${params}`, {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Lang': 'es'
                }
            });
            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `titulos_ingram.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            } else {
                console.error("Failed to download excel");
            }
        } catch (error) {
            console.error("Error downloading excel:", error);
        }
    };

    const handleSearch = () => {
        setFilters(prev => ({ ...prev, search: searchInput }));
        setRefreshKey(prev => prev + 1);
    };

    const handleClearSearch = () => {
        setSearchInput('');
        setFilters(prev => ({ ...prev, search: '' }));
        setRefreshKey(prev => prev + 1);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') handleSearch();
        if (e.key === 'Escape') handleClearSearch();
    };

    const handleStatusFilter = (status) => {
        setFilters(prev => ({ ...prev, status }));
        //setRefreshKey(prev => prev + 1);
    };

    const handleAccountChange = (option) => {
        setFilters(prev => ({ ...prev, account: option.value }));
        setRefreshKey(prev => prev + 1);
    };


    const handleExcelSuccess = () => {
        handleReload();
    };

    const STATUS_OPTIONS = [
        { value: '', label: 'Todos', icon: null },
        { value: 'on', label: 'ON', icon: faToggleOn, color: theme.primary },
        { value: 'off', label: 'OFF', icon: faToggleOff, color: theme.dangerText },
    ];

    return (
        <>
            <Heading title="Ingram" />

            {/* Toolbar section */}
            <section className="container mt-4 pb-4 border-bottom border-secondary">
                <div className="row g-3 align-items-end">

                    {/* Search */}
                    <div className="col-md-5 col-lg-4">
                        <label className="fw-bold mb-2 d-block text-white small text-uppercase opacity-75">
                            Buscar título / ISBN / SKU
                        </label>
                        <div className="d-flex search" style={{ maxWidth: 380 }}>
                            <input
                                type="text"
                                placeholder="Título, ISBN, contributor..."
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onKeyDown={handleKeyPress}
                                style={{ flex: 1 }}
                            />
                            {searchInput ? (
                                <button onClick={handleClearSearch} title="Limpiar">
                                    <FontAwesomeIcon icon={faClose} />
                                </button>
                            ) : (
                                <button onClick={handleSearch} title="Buscar">
                                    <FontAwesomeIcon icon={faSearch} />
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Account filter */}
                    <div className="col-md-3 col-lg-3">
                        <label className="fw-bold mb-2 d-block text-white small text-uppercase opacity-75">
                            Filtrar por Cuenta
                        </label>
                        <Autocomplete options={accounts} onChange={handleAccountChange} isDark={true} />
                    </div>


                    {/* Status filter */}
                    <div className="col-md-4 col-lg-3">
                        <label className="fw-bold mb-2 d-block text-white small text-uppercase opacity-75">
                            Estado Ingram
                        </label>
                        <div className="d-flex gap-2">
                            {STATUS_OPTIONS.map(opt => (
                                <button
                                    key={opt.value}
                                    onClick={() => handleStatusFilter(opt.value)}
                                    className="btn"
                                    style={{
                                        padding: '6px 14px',
                                        borderRadius: '8px',
                                        fontSize: '0.8rem',
                                        fontWeight: 600,
                                        border: filters.status === opt.value
                                            ? `2px solid ${opt.color || theme.primary}`
                                            : '2px solid rgba(var(--ink-overlay-rgb),0.15)',
                                        background: filters.status === opt.value
                                            ? `${opt.color || theme.primary}22`
                                            : 'rgba(var(--ink-overlay-rgb),0.04)',
                                        color: filters.status === opt.value
                                            ? (opt.color || theme.primaryHover)
                                            : 'var(--ink-text-dim)',
                                        transition: 'all 0.2s',
                                    }}
                                >
                                    {opt.icon && <FontAwesomeIcon icon={opt.icon} className="me-1" />}
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Actions */}
                    <div className="col-md-12 col-lg-4 d-flex justify-content-end gap-2">

                        {/* Download Excel button */}
                        <button
                            className="btn d-flex align-items-center gap-2"
                            onClick={handleDownloadExcel}
                            style={{
                                background: theme.primary,
                                color: '#fff',
                                border: 'none',
                                borderRadius: '10px',
                                padding: '8px 18px',
                                fontWeight: 600,
                                fontSize: '0.875rem',
                                boxShadow: `0 2px 12px rgba(${theme.primaryRgb},0.35)`,
                                transition: 'transform 0.15s, box-shadow 0.15s',
                            }}
                            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = `0 4px 18px rgba(${theme.primaryRgb},0.5)`; }}
                            onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = `0 2px 12px rgba(${theme.primaryRgb},0.35)`; }}
                            title="Descargar listado actual"
                        >
                            <FontAwesomeIcon icon={faDownload} />
                            Descargar
                        </button>

                        {/* Excel upload button */}
                        <button
                            className="btn d-flex align-items-center gap-2"
                            onClick={() => setIsExcelModalOpen(true)}
                            style={{
                                background: theme.primary,
                                color: '#fff',
                                border: 'none',
                                borderRadius: '10px',
                                padding: '8px 18px',
                                fontWeight: 600,
                                fontSize: '0.875rem',
                                boxShadow: `0 2px 12px rgba(${theme.primaryRgb},0.35)`,
                                transition: 'transform 0.15s, box-shadow 0.15s',
                            }}
                            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = `0 4px 18px rgba(${theme.primaryRgb},0.5)`; }}
                            onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = `0 2px 12px rgba(${theme.primaryRgb},0.35)`; }}
                        >
                            <FontAwesomeIcon icon={faFileExcel} />
                            Subir Excel
                        </button>

                        {/* Reload */}
                        <button
                            className="btn btn-ink-icon"
                            onClick={handleReload}
                            title="Recargar datos"
                        >
                            <FontAwesomeIcon icon={faSync} />
                        </button>
                    </div>
                </div>

                {/* Active filter badges */}
                {(filters.search || filters.status || filters.account) && (
                    <div className="d-flex gap-2 mt-3 flex-wrap">
                        {filters.account && (
                            <div className="d-inline-flex align-items-center bg-dark border border-secondary rounded px-3 py-1 gap-2">
                                <span className="text-white-50 small">Cuenta:</span>
                                <span className="text-white small fw-medium">{filters.account}</span>
                                <button
                                    className="btn btn-link p-0 text-danger"
                                    style={{ textDecoration: 'none', lineHeight: 1 }}
                                    onClick={() => handleAccountChange({ value: '' })}
                                >
                                    <FontAwesomeIcon icon={faClose} size="xs" />
                                </button>
                            </div>
                        )}
                        {filters.search && (

                            <div className="d-inline-flex align-items-center bg-dark border border-secondary rounded px-3 py-1 gap-2">
                                <span className="text-white-50 small">Búsqueda:</span>
                                <span className="text-white small fw-medium">{filters.search}</span>
                                <button
                                    className="btn btn-link p-0 text-danger"
                                    style={{ textDecoration: 'none', lineHeight: 1 }}
                                    onClick={handleClearSearch}
                                >
                                    <FontAwesomeIcon icon={faClose} size="xs" />
                                </button>
                            </div>
                        )}
                        {filters.status && (
                            <div className="d-inline-flex align-items-center bg-dark border border-secondary rounded px-3 py-1 gap-2">
                                <span className="text-white-50 small">Estado:</span>
                                <span
                                    className="small fw-bold"
                                    style={{ color: filters.status === 'on' ? '#4ade80' : '#f87171' }}
                                >
                                    {filters.status.toUpperCase()}
                                </span>
                                <button
                                    className="btn btn-link p-0 text-danger"
                                    style={{ textDecoration: 'none', lineHeight: 1 }}
                                    onClick={() => handleStatusFilter('')}
                                >
                                    <FontAwesomeIcon icon={faClose} size="xs" />
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </section>

            {/* Table */}
            <div className="container mt-4">
                <ContentIngram filters={filters} refreshKey={refreshKey} />
            </div>

            {/* Excel modal */}
            <IngramExcelModal
                isOpen={isExcelModalOpen}
                onClose={() => setIsExcelModalOpen(false)}
                onSuccess={handleExcelSuccess}
                account={filters.account}
            />

        </>
    );
}

export default Ingram;
